import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule,ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule,HTTP_INTERCEPTORS} from '@angular/common/http';
import {RecaptchaModule} from 'ng-recaptcha';

import {LayoutRoutingModule} from './layout-routing.module';
import {CheckPermessoService} from '../shared/check-permesso.service';

import {TokenInterceptor} from '../http-utility/token.interceptor';
import {HttpService} from '../http-utility/http.service';
import {LayoutComponent} from './layout.component';
import {FooterComponent} from './components/footer.component';

@NgModule({
  imports: [
    LayoutRoutingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RecaptchaModule
  ],
  declarations: [
    LayoutComponent,
    FooterComponent,
  ],
  providers: [
    CheckPermessoService,
    HttpService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }
  ]
})
export class LayoutModule {
}
